import Vue from "vue";
import Router from "vue-router";
import Tracking from "./views/Tracking.vue";

const Error = () => import(/* webpackChunkName: "g1" */ "./views/Error.vue");

const Main = () => import(/* webpackChunkName: "g2" */ "./views/Main.vue");

Vue.use(Router);

const router = new Router({
  mode: 'history', // Ensures clean URLs without the hash #
  routes: [
    {
      path: '/:linkid', // Dynamic route matching 'id'
      name: 'Tracking',
      props: true,
      component: Tracking, // Component to render
    },
    { path: "*", component: Error }, // Catch-all route for 404 errors
  ],
});

export default router;
